module.exports = __webpack_public_path__ + "650f6d2f12e900e69c1074f7e3f4472d.svg";